import React from 'react'

export default function index() {
    return (
        <div>Version:1.0.1</div>
    )
}
